
import React, { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { CheckCircle, XCircle, FileText, User, Building, CreditCard } from 'lucide-react';
import { toast } from 'react-toastify';
// import {XCircleIcon } from "@heroicons/react/solid";
import axios from 'axios';
import NavBar from '../../component/b2c/navBar/navBar';
import Sidebar from '../../component/b2c/sidebar/sidebar';
import { useMyContext } from '../../context/MyContext';
import { Base_Url, userlist, userdocApprove, Url_For_View_Document, deleteuser } from '../../config/config';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
// import { useAuth } from '../../../routes/Auth';
import { useAuth } from '../../routes/Auth';
import { FaEye } from 'react-icons/fa'
import { MdDeleteForever } from "react-icons/md";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import ViewAllCustomerModel from '../../component/b2c/models/ViewAllCustomerModel'

const KYCPending = () => {
  const { isAuthenticated } = useAuth();
  const [loading, setLoading] = useState(false);
  const { isToggleSidebar, isDarkMode } = useMyContext();
  const [customers, setCustomers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQueryByName, SearchQueryByName] = useState('');
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [selectedApproval, setSelectedApproval] = useState({});
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCustomers, setTotalCustomers] = useState();
  const [limit, setLimit] = useState(10);
  const role = localStorage.getItem('role');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [originalTotalCustomers, setOriginalTotalCustomers] = useState(0);

  const navigate = useNavigate();

  const goTobankReq = () => {
    navigate("/allReqForBankdoc")
  }
  useEffect(() => {
    getDocumentList();
  }, [currentPage, limit]);


  const getDocumentList = async () => {
    const url = `${Base_Url}admin/${userlist}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        const filteredCustomers = data.data.filter(customer => customer.role !== 'admin');
        const adminCount = data.data.filter(customer => customer.role === 'admin').length;
        const adjustedTotal = data.pagination.totalItems - adminCount;
        setCustomers(filteredCustomers);
        setTotalCustomers(adjustedTotal)
        setOriginalTotalCustomers(adjustedTotal);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const handlePaginationChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setCurrentPage(1);
  };

  const handleRadioChange = (customerId, documentType, status) => {
    setSelectedApproval((prev) => ({
      ...prev,
      [customerId]: {
        ...prev[customerId],
        [documentType]: status
      }
    }));
  };

  const hasAnyRadioSelection = (customer) => {
    const customerSelections = selectedApproval[customer.id] || {};

    const hasPendingAadhar = customer.user_address_image && customer.aadhar_status === "0";
    const hasPendingPan = customer.user_pancard_image && customer.pan_card_status === "0";
    const hasPendingGst = customer.user_gst_image && customer.gst_status === "0";

    const hasAadharSelection = hasPendingAadhar && customerSelections.address;
    const hasPanSelection = hasPendingPan && customerSelections.pancard;
    const hasGstSelection = hasPendingGst && customerSelections.gstin;

    return hasAadharSelection || hasPanSelection || hasGstSelection;
  };

  const shouldShowSubmitButton = (customer) => {
    const allApproved =
      customer.aadhar_status === "1" &&
      customer.pan_card_status === "1" &&
      customer.gst_status === "1";

    const allRejected =
      customer.aadhar_status === "2" &&
      customer.pan_card_status === "2" &&
      customer.gst_status === "2";

    const noDocuments =
      !customer.user_address_image &&
      !customer.user_pancard_image &&
      !customer.user_gst_image;

    // Show only if there are pending documents and at least one radio selection
    return !allApproved && !allRejected && !noDocuments && hasAnyRadioSelection(customer);
  };

  const handleSubmit = async (customerId) => {
    const customer = customers.find(c => c.id === customerId);
    const hasAadharDoc = customer?.user_address_image;
    const hasPanDoc = customer?.user_pancard_image;
    const hasGstDoc = customer?.user_gst_image;
    const aadharStatus = customer?.aadhar_status;
    const panStatus = customer?.pan_card_status;
    const gstStatus = customer?.gst_status;

    // Check selected statuses from the UI
    const selectedAadhar = selectedApproval[customerId]?.address;
    const selectedPan = selectedApproval[customerId]?.pancard;
    const selectedGst = selectedApproval[customerId]?.gstin;

    // Collect missing selections only for documents that are not already approved
    const missingSelections = [];

    if (hasAadharDoc && aadharStatus !== "1" && !selectedAadhar) {
      missingSelections.push("Aadhaar");
    }
    if (hasPanDoc && panStatus !== "1" && !selectedPan) {
      missingSelections.push("PAN Card");
    }
    if (hasGstDoc && gstStatus !== "1" && !selectedGst) {
      missingSelections.push("GSTIN");
    }
    // Show error if there are missing selections
    if (missingSelections.length > 0) {
      toast.error(
        `Please select approval or reject status for: ${missingSelections.join(", ")}`
      );
      return;
    }
    try {
      setLoading((prev) => ({ ...prev, [customerId]: true }));
      const approvalData = {
        customer_id: customerId,
        aadhar_status: aadharStatus === "1" ? "1" : selectedApproval[customerId]?.address,
        pancard_status: panStatus === "1" ? "1" : selectedApproval[customerId]?.pancard,
        gst_status: gstStatus === "1" ? "1" : selectedApproval[customerId]?.gstin,
      };

      const response = await axios.post(
        `${Base_Url}admin/${userdocApprove}`,
        approvalData,
        {
          headers: {
            token: token,
            cus_id: cus_id,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === true) {
        toast.success("Documents Updated Successfully!");
        getDocumentList();
      } else {
        toast.error(`Error: ${response.data.message}`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    } finally {
      setLoading((prev) => ({ ...prev, [customerId]: false }));
    }
  };
  const handleDocumentClick = (url) => {
    if (!isAuthenticated) {
      window.location.href = '/dashboard';
    } else {
      window.open(url, '_blank');
    }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    if (!/^\d{0,12}$/.test(value)) {
      return;
    }
    setSearchQuery(value);
    setCurrentPage(1);
    if (value.length === 12) {
      const filtered = customers.filter((customer) =>
        customer.aadhar_number?.toLowerCase().includes(value.toLowerCase())
      );
      // if (filtered.length === 0) {
      //   toast.error("No customer found with this Aadhaar number.");
      // }
      setFilteredCustomers(filtered);
      setTotalCustomers(filtered.length);
    } else if (value === "") {
      setFilteredCustomers([]);
      setTotalCustomers(originalTotalCustomers);
    }
  };


  useEffect(() => {
    let filtered = customers;

    if (searchQuery.trim() !== '') {
      filtered = filtered.filter(customer =>
        customer.aadhar_number?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (searchQueryByName.trim() !== '') {
      filtered = filtered.filter(customer =>
        customer.name?.toLowerCase().includes(searchQueryByName.toLowerCase())
      );
    }

    setFilteredCustomers(filtered);
  }, [searchQuery, searchQueryByName, customers]);


  const handleSearchChangeByName = (event) => {
    const value = event.target.value;
    SearchQueryByName(value);
    setCurrentPage(1);

    if (value.length > 0) {
      const filtered = customers.filter((customer) =>
        customer.name?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCustomers(filtered);
      setTotalCustomers(filtered.length);
    } else if (value === "") {
      setFilteredCustomers([]);
      setTotalCustomers(originalTotalCustomers);
    }
  };
  const handleClick = (customer) => {
    setSelectedCustomer(customer);
    setIsPopupOpen(true);
  };
  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleDelete = async (customer) => {
    // Show SweetAlert confirmation dialog
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this deletion!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      // Only proceed with deletion if user confirms
      if (result.isConfirmed) {
        const urldelete = Base_Url + deleteuser;
        try {
          const token = localStorage.getItem('token');
          const cusid = localStorage.getItem('cus_id');
          const data = {
            retailer_id: customer.id
          };
          const response = await axios.post(urldelete, data, {
            headers: {
              token,
              cus_id: cusid,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });

          if (response.data.status === "SUCCESS") {
            getDocumentList();
            Swal.fire(
              'Deleted!',
              response.data.message || 'Reatiler has been deleted successfully.',
              'success'
            );
          } else {
            // Show error message using SweetAlert
            Swal.fire(
              'Error!',
              'Unexpected response format: ' + response.data.message,
              'error'
            );
          }
        } catch (error) {
          // Show error message using SweetAlert
          Swal.fire(
            'Error!',
            'Error deleting Retailer: ' + error.message,
            'error'
          );
        }
      }
    });
  };

  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className="fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20"
            style={window.innerWidth < 768 ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' } : {}}>
            <Sidebar />
          </div>
        )}
        <div className="min-h-screen dark:bg-darkmodeColor p-4 w-full overflow-y-auto">
          <div className="max-w-7xl mx-auto mb-36 ">
            <div className="mb-6 grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* First Search Bar */}
              <div className="relative w-full">
                <input
                  type="text"
                  placeholder="Search by Aadhaar number..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className="w-full px-4 py-2 pr-10 rounded-lg border border-gray-300 dark:border-gray-700 
            bg-white dark:bg-darkmodeColor text-gray-900 dark:text-white
            focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              </div>

              {/* Second Search Bar */}
              <div className="relative w-full">
                <input
                  type="text"
                  placeholder="Search by Name..."
                  value={searchQueryByName}
                  onChange={handleSearchChangeByName}
                  className="w-full px-4 py-2 pr-10 rounded-lg border border-gray-300 dark:border-gray-700 
            bg-white dark:bg-darkmodeColor text-gray-900 dark:text-white
            focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              </div>

              <div className="relative w-full">
                <button
                  className="w-full h-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-700 
            bg-blue-500 dark:bg-blue-600 text-white
            focus:outline-none focus:ring-2 focus:ring-blue-500 flex items-center justify-center"
                  onClick={goTobankReq}
                >
                  All Request For Update Bank Document
                </button>
              </div>

            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {
                (searchQuery.trim().length === 12 && filteredCustomers.length === 0) ? (
                  <div className="col-span-full text-center top-96 text-red-500  font-bold dark:text-white">
                    No customers found with this Aadhaar number.
                  </div>) : (
                  (searchQueryByName.trim().length > 0 && filteredCustomers.length === 0) ?
                    (<div className="col-span-full text-center top-96 text-red-500  font-bold dark:text-white">
                      No customers found with this Name.
                    </div>
                    ) :
                    (filteredCustomers.length > 0 ? filteredCustomers : customers).map((customer) => (
                      <div key={customer.id} className="bg-white dark:bg-darkmodeColor shadow-custom-light dark:shadow-custom-dark rounded-lg overflow-hidden p-6 flex flex-col h-full">
                        <div className="border-b border-gray-200 dark:border-gray-700 pb-4 mb-4 flex justify-between items-center">
                          <h2 className="text-lg font-bold text-gray-800 dark:text-white flex items-center gap-2">
                            <User className="w-5 h-5" />
                            {customer.name}
                          </h2>
                          <div className="flex items-center gap-4">
                            <button
                              className="text-blue-600 hover:text-blue-700"
                              onClick={() => handleClick(customer)}
                            >
                              <FaEye className="w-5 h-5" />
                            </button>
                            <button
                              className="text-red-600 hover:text-red-700"
                              onClick={() => handleDelete(customer)}
                            >
                              <MdDeleteForever className="w-5 h-5" />
                            </button>
                          </div>
                        </div>

                        <div className="space-y-2">
                          <h3 className="text-sm font-semibold text-gray-800 dark:text-white flex items-center gap-2">
                            <Building className="w-4 h-4" /> Company Type: {customer.company_type || 'N/A'}
                          </h3>
                        </div>
                        <div className="space-y-2 mt-4">
                          <h3 className="text-sm font-semibold text-gray-800 dark:text-white flex items-center gap-2">
                            <CreditCard className="w-4 h-4" /> ID Information
                          </h3>
                          <p className="text-sm text-gray-600 dark:text-gray-300">GSTIN: {customer.gst_number || 'N/A'}</p>
                          <p className="text-sm text-gray-600 dark:text-gray-300">Aadhaar: {customer.aadhar_number || 'N/A'}</p>
                          <p className="text-sm text-gray-600 dark:text-gray-300">PAN: {customer.pancard_number || 'N/A'}</p>
                        </div>
                        <div className="space-y-2 mt-4">
                          <h3 className="text-sm font-semibold text-gray-800 dark:text-white flex items-center gap-2">
                            <FileText className="w-4 h-4" /> Documents
                          </h3>
                          {customer.user_address_image && (
                            <div className="flex items-center justify-between">
                              <span className="text-sm text-gray-600 dark:text-gray-300">Aadhaar:</span>
                              <div className="flex items-center gap-2">
                                <button
                                  className="text-sm text-blue-600 hover:text-blue-700"
                                  onClick={() => handleDocumentClick(Url_For_View_Document + customer.user_address_image)}
                                >
                                  View
                                </button>
                                {customer.aadhar_status === "1" ? (
                                  <CheckCircle className="text-green-500 w-5 h-5" />
                                ) : customer.aadhar_status === "2" ? (
                                  <XCircle className="text-red-500 w-5 h-5" />)
                                  : (
                                    <>
                                      <label className="flex items-center gap-2">
                                        <input
                                          type="radio"
                                          name={`approval-${customer.id}-address`}
                                          value="1"
                                          checked={selectedApproval[customer.id]?.address === "1"}
                                          onChange={() => handleRadioChange(customer.id, 'address', "1")}
                                        />
                                        Approve
                                      </label>
                                      <label className="flex items-center gap-2">
                                        <input
                                          type="radio"
                                          name={`approval-${customer.id}-address`}
                                          value="2"
                                          checked={selectedApproval[customer.id]?.address === "2"}
                                          onChange={() => handleRadioChange(customer.id, 'address', "2")}
                                        />
                                        Reject
                                      </label>
                                    </>
                                  )}
                              </div>
                            </div>
                          )}
                          {customer.user_pancard_image && (
                            <div className="flex items-center justify-between">
                              <span className="text-sm text-gray-600 dark:text-gray-300">PAN Card:</span>
                              <div className="flex items-center gap-2">
                                <button
                                  className="text-sm text-blue-600 hover:text-blue-700"
                                  onClick={() => handleDocumentClick(Url_For_View_Document + customer.user_pancard_image)}
                                >
                                  View
                                </button>
                                {customer.pan_card_status === "1" ? (
                                  <CheckCircle className="text-green-500 w-5 h-5" />
                                ) : customer.pan_card_status === "2" ? (
                                  <XCircle className="text-red-500 w-5 h-5" />
                                ) :
                                  (
                                    <>
                                      <label className="flex items-center gap-2">
                                        <input
                                          type="radio"
                                          name={`approval-${customer.id}-pancard`}
                                          value="1"
                                          checked={selectedApproval[customer.id]?.pancard === "1"}
                                          onChange={() => handleRadioChange(customer.id, 'pancard', "1")}
                                        />
                                        Approve
                                      </label>
                                      <label className="flex items-center gap-2">
                                        <input
                                          type="radio"
                                          name={`approval-${customer.id}-pancard`}
                                          value="2"
                                          checked={selectedApproval[customer.id]?.pancard === "2"}
                                          onChange={() => handleRadioChange(customer.id, 'pancard', "2")}
                                        />
                                        Reject
                                      </label>
                                    </>
                                  )}
                              </div>
                            </div>
                          )}
                          {customer.user_gst_image && (
                            <div className="flex items-center justify-between">
                              <span className="text-sm text-gray-600 dark:text-gray-300">GSTIN:</span>
                              <div className="flex items-center gap-2">
                                <button
                                  className="text-sm text-blue-600 hover:text-blue-700"
                                  onClick={() => handleDocumentClick(Url_For_View_Document + customer.user_gst_image)}
                                >
                                  View
                                </button>
                                {customer.gst_status === "1" ? (
                                  <CheckCircle className="text-green-500 w-5 h-5" />
                                ) : customer.gst_status === "2" ? (
                                  <XCircle className="text-red-500 w-5 h-5" />) :
                                  (
                                    <>
                                      <label className="flex items-center gap-2">
                                        <input
                                          type="radio"
                                          name={`approval-${customer.id}-gstin`}
                                          value="1"
                                          checked={selectedApproval[customer.id]?.gstin === "1"}
                                          onChange={() => handleRadioChange(customer.id, 'gstin', "1")}
                                        />
                                        Approve
                                      </label>
                                      <label className="flex items-center gap-2">
                                        <input
                                          type="radio"
                                          name={`approval-${customer.id}-gstin`}
                                          value="2"
                                          checked={selectedApproval[customer.id]?.gstin === "2"}
                                          onChange={() => handleRadioChange(customer.id, 'gstin', "2")}
                                        />
                                        Reject
                                      </label>
                                    </>
                                  )}
                              </div>
                            </div>
                          )}
                        </div>

                        {/* <div className="space-y-2 mt-4">
                          <h3 className="text-sm font-semibold text-gray-800 dark:text-white flex items-center gap-2">
                            <FileText className="w-4 h-4" /> Shipment Preference
                          </h3>

                          <div className="flex items-center gap-4 text-sm text-gray-700 dark:text-gray-300">

                            <label className="flex items-center gap-2">
                              <input
                                type="radio"
                                name={`shipment-${customer.id}`}
                                value="heavy"
                                checked={selectedApproval[customer.id]?.shipment === "heavy"}
                                onChange={() => handleRadioChange(customer.id, "shipment", "heavy")}
                              />
                              Heavy Shipment
                            </label>

                            <label className="flex items-center gap-2">
                              <input
                                type="radio"
                                name={`shipment-${customer.id}`}
                                value="both"
                                checked={selectedApproval[customer.id]?.shipment === "both"}
                                onChange={() => handleRadioChange(customer.id, "shipment", "both")}
                              />
                              Heavy + Light Both
                            </label>

                          </div>
                        </div> */}

                        <div className="mt-4">
                          {customer.aadhar_status === "1" &&
                            customer.pan_card_status === "1" &&
                            customer.gst_status === "1" ? (
                            <p className="bg-green-500 text-white px-4 py-2 rounded-lg text-center">
                              Document Verified
                            </p>
                          ) : customer.aadhar_status === "2" &&
                            customer.pan_card_status === "2" &&
                            customer.gst_status === "2" ? (
                            <p className="bg-red-500 text-white px-4 py-2 rounded-lg text-center">
                              Document Rejected
                            </p>
                          ) : !customer.user_address_image &&
                            !customer.user_pancard_image &&
                            !customer.user_gst_image ? (
                            <p className="font-medium text-medium text-red-500 px-4 py-2 rounded-lg">
                              Upload Required Documents to Update the KYC
                            </p>
                          ) : shouldShowSubmitButton(customer) ? (
                            <button
                              className="bg-blue-600 text-white px-4 py-2 rounded-lg w-full"
                              onClick={() => handleSubmit(customer.id)}
                              disabled={loading[customer.id]}
                            >
                              {loading[customer.id] ? "Submitting..." : "Submit"}
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    ))
                )}
            </div>
            <div className="mt-4 flex flex-col sm:flex-row mb-8 justify-between items-center space-y-2 sm:space-y-0">
              {/* <span className="text-sm text-gray-700  font-bold dark:text-gray-300">{`Total Customers: ${totalCustomers}`}</span> */}
              <span className="text-sm text-gray-700 font-bold dark:text-gray-300">
                {`Total Customers: ${totalCustomers}`}
                {/* {searchQuery && ` (Filtered: ${filteredCustomers.length})`} */}
              </span>
              <select
                id="limit"
                value={limit}
                onChange={handleLimitChange}
                className="border rounded p-1 text-sm bg-white dark:bg-darkmodeColor dark:text-gray-200"
              >
                {totalCustomers === 0 ? (
                  <option value={0}>0</option>
                ) : (
                  <>
                    {totalCustomers >= 10 && <option value={10}>10</option>}
                    {totalCustomers >= 15 && <option value={15}>15</option>}
                    {totalCustomers >= 20 && <option value={20}>20</option>}
                    {totalCustomers > 30 && <option value={totalCustomers}>All</option>}
                  </>
                )}
              </select>
              <Pagination
                count={Math.ceil(totalCustomers / limit)}
                page={currentPage}
                onChange={handlePaginationChange}
                color="primary"
                variant="outlined"
                shape="rounded"
                size="small"
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    className={`paginationItem border text-blue-600 dark:text-blue-400 hover:text-white dark:hover:text-white border-gray-200 dark:border-gray-700`}
                  />
                )}
              />
            </div>
            <ViewAllCustomerModel isopen={isPopupOpen} onClose={handleClose} customer={selectedCustomer} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KYCPending;